import { MessageType } from '@web/conversations/types/MessageType';
import { MessageMeta as MessageMetaType } from '@web/conversations/types/Message';
import {
  MessageAlternativeLayout,
  MessageInfoText,
  MessageWrapper,
} from '@web/conversations/Message/MessageLayout/MessageLayout';

import { getCreationMetaMessage, getRenamingMetaMessage } from './messageMeta.utils';

type Props = {
  message: MessageMetaType;
};
export const MessageMeta = ({ message }: Props) => {
  const isCreation = message.type === MessageType.CREATION;
  const description = isCreation
    ? getCreationMetaMessage(message)
    : getRenamingMetaMessage(message);

  return (
    <MessageAlternativeLayout>
      <MessageWrapper>
        <MessageInfoText>{description}</MessageInfoText>
      </MessageWrapper>
    </MessageAlternativeLayout>
  );
};
